var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04133 2.30383V3.99346L1.72314 7.45582V21.8038H22.9959V7.45582L17.6777 3.99346V2.30383H7.04133ZM8.81405 4.07656H15.905V10.8905L12.3595 13.1895L8.81405 10.8905V4.07656ZM9.70042 5.84929V7.62201H15.0186V5.84929H9.70042ZM7.04133 6.09858V9.72713L4.24374 7.9267L7.04133 6.09858ZM17.6777 6.09858L20.4753 7.9267L17.6777 9.72713V6.09858ZM9.70042 8.50838V10.2811H15.0186V8.50838H9.70042ZM3.49587 9.56094L12.3595 15.2946L21.2231 9.56094V20.0311H3.49587V9.56094Z",
    fill: "#29AEE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.1823d08f.svg";
export { ForwardRef as ReactComponent };